const P = (x, mt) => ({ t: "p", x, mt });
const H = (x) => ({ t: "h3", x });
const UL = (items) => ({ t: "ul", items });
const OL = (items) => ({ t: "ol", items });
const BOX = (items) => ({ t: "box", items });
const CALLOUT = (c, title, x, items, after, icon) => ({ t: "callout", c, title, x, items, after, icon, my: true });

const refundPolicy = {
  en: {
    refundPage: {
      back: "Back to Home",
      title: "Refund Policy",
      lastUpdated: "Last Updated: January 18, 2025",
      links: { privacy: "Privacy Policy", terms: "Terms of Service", cookies: "Cookie Policy" },
      footer: "Summary: Try EReMS Cameroon risk-free for 7 days. If not satisfied, request a full refund. After 7 days, you can cancel anytime but no refund for the current period.",
      sections: [
        { h: "1. Overview", blocks: [
          P("This Refund Policy outlines the terms and conditions for refunds and cancellations of EReMS Cameroon subscriptions. We strive to provide excellent service and fair refund policies."),
        ] },
        { h: "2. Subscription Plans", blocks: [
          P("EReMS Cameroon offers the following subscription plans:"),
          UL([
            "**Free Plan:** $0 - No payment required",
            "**Basic Plan:** $200/month",
            "**Professional Plan:** $500/month",
            "**Enterprise Plan:** Custom pricing",
          ]),
        ] },
        { h: "3. 7-Day Money-Back Guarantee", blocks: [
          CALLOUT("green", "NEW SUBSCRIBERS ONLY:",
            "If you are not satisfied with EReMS Cameroon within the first 7 days of your initial subscription, we will provide a full refund - no questions asked."),
          H("3.1 Eligibility"),
          UL([
            "Applies to first-time subscribers only",
            "Request must be made within 7 days of initial payment",
            "Not applicable to renewal payments",
            "Not applicable to Enterprise custom plans",
          ]),
          H("3.2 How to Request"),
          P("To request a refund under the 7-day guarantee:"),
          OL([
            "Email: **mboatechnologyllc@gmail.com**",
            "Include your account email and transaction ID",
            "Specify reason for refund (optional)",
            "We will process within 5-7 business days",
          ]),
        ] },
        { h: "4. Cancellation Policy", blocks: [
          H("4.1 How to Cancel"),
          P("You can cancel your subscription anytime:"),
          UL([
            "Log into your account",
            "Go to Subscription settings",
            "Click \"Cancel Subscription\"",
            "Confirm cancellation",
          ]),
          H("4.2 What Happens After Cancellation"),
          UL([
            "You retain access until the end of your billing period",
            "No further charges will be made",
            "Your data remains accessible for 30 days",
            "After 30 days, account may be downgraded to Free plan",
          ]),
          H("4.3 No Partial Refunds"),
          CALLOUT("yellow", null,
            "If you cancel after the 7-day guarantee period, you will NOT receive a refund for the current billing period. You will continue to have access until the period ends.",
            null, null, "alert"),
        ] },
        { h: "5. Refund Exceptions", blocks: [
          H("5.1 When Refunds Are NOT Provided"),
          UL([
            "After the 7-day guarantee period",
            "For renewal payments",
            "For services already rendered",
            "For account violations or terminations",
            "For \"change of mind\" after 7 days",
            "For partial month usage",
          ]),
          H("5.2 When Refunds MAY Be Provided"),
          P("Outside the 7-day period, refunds may be considered for:"),
          UL([
            "**Technical Issues:** If service is unavailable for extended periods",
            "**Billing Errors:** Duplicate charges or incorrect amounts",
            "**Unauthorized Charges:** If account was compromised",
            "**Force Majeure:** Events beyond our control",
          ]),
          P("These are evaluated case-by-case. Contact us to discuss.", true),
        ] },
        { h: "6. Downgrade Policy", blocks: [
          H("6.1 Plan Downgrade"),
          P("You can downgrade your plan anytime:"),
          UL([
            "Professional → Basic: Effective next billing cycle",
            "Basic → Free: Effective immediately, no refund for remaining time",
          ]),
          H("6.2 Data Retention After Downgrade"),
          UL([
            "All data is retained",
            "Access limited based on new plan features",
            "API call limits adjusted immediately",
          ]),
        ] },
        { h: "7. Upgrade Policy", blocks: [
          P("When upgrading your subscription:"),
          UL([
            "Upgrade takes effect immediately",
            "You are charged the prorated difference",
            "New features available right away",
            "Next billing will be for the new plan amount",
          ]),
        ] },
        { h: "8. Failed Payments", blocks: [
          H("8.1 Retry Attempts"),
          P("If a payment fails:"),
          UL([
            "We will attempt to charge again after 3 days",
            "Second attempt after 7 days",
            "Final attempt after 10 days",
          ]),
          H("8.2 Service Suspension"),
          P("If all retry attempts fail, your subscription will be cancelled and access will be limited. No refund is provided for partial service."),
        ] },
        { h: "9. Refund Processing", blocks: [
          H("9.1 Timeline"),
          UL([
            "**Request Review:** 1-2 business days",
            "**Approval Notification:** Within 3 business days",
            "**Refund Processing:** 5-7 business days",
            "**Bank Processing:** Additional 3-5 business days",
          ]),
          H("9.2 Refund Method"),
          P("Refunds are issued to the original payment method used for the purchase."),
        ] },
        { h: "10. Enterprise Plans", blocks: [
          P("Enterprise plans have custom terms. Refund and cancellation policies are outlined in your specific agreement. Contact your account manager for details."),
        ] },
        { h: "11. Disputes", blocks: [
          P("If you have a billing dispute:"),
          OL([
            "Contact us first: **mboatechnologyllc@gmail.com**",
            "Provide transaction details and explanation",
            "We will investigate within 5 business days",
            "If unresolved, you may contact your payment provider",
          ]),
          { t: "warning", x: "**Warning:** Initiating a chargeback without contacting us first may result in immediate account suspension." },
        ] },
        { h: "12. Changes to This Policy", blocks: [
          P("We may update this Refund Policy from time to time. Changes will be posted on this page with an updated \"Last Updated\" date. Significant changes will be communicated via email."),
        ] },
        { h: "13. Contact Us", blocks: [
          P("Questions about refunds or cancellations?"),
          BOX([
            "**Operator:** M-TECH",
            "**Email:** mboatechnologyllc@gmail.com",
          ]),
        ] },
      ],
    },
  },
  fr: {
    refundPage: {
      back: "Retour à l'accueil",
      title: "Politique de remboursement",
      lastUpdated: "Dernière mise à jour : 18 janvier 2025",
      links: { privacy: "Politique de confidentialité", terms: "Conditions d'utilisation", cookies: "Politique relative aux cookies" },
      footer: "Résumé : essayez EReMS Cameroon sans risque pendant 7 jours. Si vous n'êtes pas satisfait, demandez un remboursement intégral. Après 7 jours, vous pouvez résilier à tout moment, mais aucun remboursement ne sera accordé pour la période en cours.",
      sections: [
        { h: "1. Aperçu", blocks: [
          P("La présente Politique de remboursement définit les conditions applicables aux remboursements et aux résiliations des abonnements EReMS Cameroon. Nous nous efforçons de fournir un excellent service et une politique de remboursement équitable."),
        ] },
        { h: "2. Formules d'abonnement", blocks: [
          P("EReMS Cameroon propose les formules d'abonnement suivantes :"),
          UL([
            "**Formule gratuite :** 0 $ – aucun paiement requis",
            "**Formule Basique :** 200 $/mois",
            "**Formule Professionnelle :** 500 $/mois",
            "**Formule Entreprise :** tarification sur mesure",
          ]),
        ] },
        { h: "3. Garantie de remboursement de 7 jours", blocks: [
          CALLOUT("green", "NOUVEAUX ABONNÉS UNIQUEMENT :",
            "Si vous n'êtes pas satisfait d'EReMS Cameroon au cours des 7 premiers jours de votre abonnement initial, nous vous rembourserons intégralement, sans aucune justification."),
          H("3.1 Éligibilité"),
          UL([
            "S'applique uniquement aux nouveaux abonnés",
            "La demande doit être effectuée dans les 7 jours suivant le paiement initial",
            "Non applicable aux paiements de renouvellement",
            "Non applicable aux formules Entreprise sur mesure",
          ]),
          H("3.2 Comment faire une demande"),
          P("Pour demander un remboursement au titre de la garantie de 7 jours :"),
          OL([
            "Envoyez un e-mail à : **mboatechnologyllc@gmail.com**",
            "Indiquez l'adresse e-mail de votre compte et l'identifiant de la transaction",
            "Précisez le motif du remboursement (facultatif)",
            "Nous traiterons votre demande sous 5 à 7 jours ouvrables",
          ]),
        ] },
        { h: "4. Politique de résiliation", blocks: [
          H("4.1 Comment résilier"),
          P("Vous pouvez résilier votre abonnement à tout moment :"),
          UL([
            "Connectez-vous à votre compte",
            "Accédez aux paramètres d'abonnement",
            "Cliquez sur « Résilier l'abonnement »",
            "Confirmez la résiliation",
          ]),
          H("4.2 Ce qui se passe après la résiliation"),
          UL([
            "Vous conservez l'accès jusqu'à la fin de votre période de facturation",
            "Aucun autre prélèvement ne sera effectué",
            "Vos données restent accessibles pendant 30 jours",
            "Après 30 jours, votre compte peut être rétrogradé vers la formule gratuite",
          ]),
          H("4.3 Aucun remboursement partiel"),
          CALLOUT("yellow", null,
            "Si vous résiliez après la période de garantie de 7 jours, vous ne recevrez AUCUN remboursement pour la période de facturation en cours. Vous continuerez à avoir accès au service jusqu'à la fin de la période.",
            null, null, "alert"),
        ] },
        { h: "5. Exceptions au remboursement", blocks: [
          H("5.1 Cas où aucun remboursement n'est accordé"),
          UL([
            "Après la période de garantie de 7 jours",
            "Pour les paiements de renouvellement",
            "Pour les services déjà fournis",
            "En cas de violation des conditions ou de résiliation du compte",
            "Pour un « changement d'avis » après 7 jours",
            "Pour une utilisation partielle du mois",
          ]),
          H("5.2 Cas où un remboursement PEUT être accordé"),
          P("Au-delà de la période de 7 jours, un remboursement peut être envisagé dans les cas suivants :"),
          UL([
            "**Problèmes techniques :** si le service est indisponible pendant de longues périodes",
            "**Erreurs de facturation :** prélèvements en double ou montants incorrects",
            "**Prélèvements non autorisés :** si le compte a été compromis",
            "**Force majeure :** événements indépendants de notre volonté",
          ]),
          P("Ces demandes sont examinées au cas par cas. Contactez-nous pour en discuter.", true),
        ] },
        { h: "6. Politique de rétrogradation", blocks: [
          H("6.1 Rétrogradation de formule"),
          P("Vous pouvez rétrograder votre formule à tout moment :"),
          UL([
            "Professionnelle → Basique : effective au prochain cycle de facturation",
            "Basique → Gratuite : effective immédiatement, sans remboursement du temps restant",
          ]),
          H("6.2 Conservation des données après rétrogradation"),
          UL([
            "Toutes les données sont conservées",
            "L'accès est limité selon les fonctionnalités de la nouvelle formule",
            "Les limites d'appels API sont ajustées immédiatement",
          ]),
        ] },
        { h: "7. Politique de mise à niveau", blocks: [
          P("Lorsque vous passez à une formule supérieure :"),
          UL([
            "La mise à niveau prend effet immédiatement",
            "La différence vous est facturée au prorata",
            "Les nouvelles fonctionnalités sont disponibles immédiatement",
            "La prochaine facturation correspondra au montant de la nouvelle formule",
          ]),
        ] },
        { h: "8. Paiements échoués", blocks: [
          H("8.1 Nouvelles tentatives"),
          P("En cas d'échec d'un paiement :"),
          UL([
            "Nous tenterons de prélever à nouveau après 3 jours",
            "Deuxième tentative après 7 jours",
            "Dernière tentative après 10 jours",
          ]),
          H("8.2 Suspension du service"),
          P("Si toutes les nouvelles tentatives échouent, votre abonnement sera résilié et votre accès sera limité. Aucun remboursement n'est accordé pour un service partiel."),
        ] },
        { h: "9. Traitement des remboursements", blocks: [
          H("9.1 Délais"),
          UL([
            "**Examen de la demande :** 1 à 2 jours ouvrables",
            "**Notification d'approbation :** sous 3 jours ouvrables",
            "**Traitement du remboursement :** 5 à 7 jours ouvrables",
            "**Traitement bancaire :** 3 à 5 jours ouvrables supplémentaires",
          ]),
          H("9.2 Mode de remboursement"),
          P("Les remboursements sont effectués sur le moyen de paiement initial utilisé pour l'achat."),
        ] },
        { h: "10. Formules Entreprise", blocks: [
          P("Les formules Entreprise sont soumises à des conditions personnalisées. Les politiques de remboursement et de résiliation sont précisées dans votre contrat spécifique. Contactez votre gestionnaire de compte pour plus de détails."),
        ] },
        { h: "11. Litiges", blocks: [
          P("En cas de litige de facturation :"),
          OL([
            "Contactez-nous d'abord : **mboatechnologyllc@gmail.com**",
            "Fournissez les détails de la transaction et une explication",
            "Nous mènerons l'enquête sous 5 jours ouvrables",
            "Si le litige n'est pas résolu, vous pouvez contacter votre prestataire de paiement",
          ]),
          { t: "warning", x: "**Avertissement :** le lancement d'une contestation de paiement (rétrofacturation) sans nous avoir contactés au préalable peut entraîner la suspension immédiate de votre compte." },
        ] },
        { h: "12. Modifications de la présente politique", blocks: [
          P("Nous pouvons mettre à jour la présente Politique de remboursement de temps à autre. Les modifications seront publiées sur cette page avec une date de « Dernière mise à jour » actualisée. Les changements importants seront communiqués par e-mail."),
        ] },
        { h: "13. Nous contacter", blocks: [
          P("Des questions sur les remboursements ou les résiliations ?"),
          BOX([
            "**Exploitant :** M-TECH",
            "**E-mail :** mboatechnologyllc@gmail.com",
          ]),
        ] },
      ],
    },
  },
};

export default refundPolicy;
